import { AppRoute, CredentialsService, LogService } from '@ebeihilfe/core';
import { CanActivateFn, Router } from '@angular/router';
import { OverlayService } from '@ebeihilfe/web-logic';
import { inject } from '@angular/core';

export const hasSecondFactor: CanActivateFn = async () => {
  const credentialsService = inject(CredentialsService);
  const router = inject(Router);
  const overlayService = inject(OverlayService);

  const start = Date.now();
  let overlayShown = false;

  try {
    const currentPinPromise = credentialsService.requestPin();
    const timeoutPromise = new Promise<void>((resolve) => setTimeout(resolve, 500));

    await Promise.race([currentPinPromise, timeoutPromise]);

    if (Date.now() - start >= 500) {
      overlayService.show();
      overlayShown = true;
    }

    const currentPin = await currentPinPromise;

    if (currentPin?.success === false && currentPin?.hasPin === true) {
      if (overlayShown) {
        overlayService.hide();
      }
      return router.navigate([AppRoute.PinValidation]);
    }

    if (overlayShown) {
      overlayService.hide();
    }
    return true;
  } catch (e) {
    if (overlayShown === true) {
      overlayService.hide();
    }
    LogService.error(e, true, 'issue in has second factor guard');

    return router.navigate([AppRoute.PinValidation]);
  }
};
